module.exports = __webpack_public_path__ + "static/media/banner_lotto5.1ea12085.svg";